import { Menu, ActionIcon, Tooltip } from '@mantine/core';
import { IconLanguage, IconCheck } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../i18n';
import { Lang } from '../i18n/locales';

export const LANGS: { code: Lang; label: string }[] = [
  { code: 'uz', label: "O'zbekcha" },
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
];

export function LanguageMenu() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language?.slice(0, 2) as Lang) || 'uz';

  return (
    <Menu shadow="md" width={170} position="bottom-end">
      <Menu.Target>
        <Tooltip label={t('lang.title')}>
          <ActionIcon variant="default" size="lg" aria-label={t('lang.title')}>
            <IconLanguage size={18} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t('lang.title')}</Menu.Label>
        {LANGS.map((l) => (
          <Menu.Item
            key={l.code}
            onClick={() => setLanguage(l.code)}
            rightSection={current === l.code ? <IconCheck size={16} /> : undefined}
            fw={current === l.code ? 700 : 400}
          >
            {l.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
